import {PUBLIC_ROUTES} from "../config/routes";

export const isPublicRoute = () =>
  Object.values(PUBLIC_ROUTES).some(({path}) => {
    return window.location.pathname.indexOf(path.replace(/:token/, "")) !== -1;
  });
